
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import item from './resumen-item.vue';
    import { ResumenPedidos } from '@/__env/lib/Ventas/Pedidos/Resumen/Resumen.nav';
    import { Wait } from '@/__env/ext';
    import { ControladorSeccion } from '@/views/a-pedidos-ml/pc/lista/controlador';
    import { Transporte } from '@/__env/lib/Expedicion/Transportes';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            item
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorSeccion;
        public Valores: any = [{}, {}, {}, {},];
        public Cargando: boolean = true;
        public EstadoSeleccionado: string = '-';
        public Estadistica: ResumenPedidos = new ResumenPedidos();


        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        async mounted()
        {
            await this.Iniciar();
            this.Eventos.push( this.Controlador.Buscador.onActualizar.subscribe( () => { this.Iniciar(); } ) );
            this.Eventos.push( this.Controlador.onRecargarEstadistica.subscribe( () => { this.Iniciar(true); } ) );

        }

        async Iniciar( forzar: boolean = false)
        {
            if ( !forzar && this.EstadoSeleccionado == this.Controlador.Buscador.Filtros.Tipos[this.Controlador.Buscador.Filtros.Valores.Tipo].Valor.map( x => x.Id ).join( ',' ) )
            {
                return;
            }

            this.Cargando = true;
            await Wait( 1500 );

            this.EstadoSeleccionado = this.Controlador.Buscador.Filtros.Tipos[this.Controlador.Buscador.Filtros.Valores.Tipo].Valor.map( x => x.Id ).join( ',' );
            this.Estadistica = await ResumenPedidos.create( this.EstadoSeleccionado );

            this.Valores.clear();

            let preparando = {
                Titulo: 'Para entregar',
                Valor: this.Estadistica.Datos.preparando.detalles['retira-cliente'],
                Accion: () => { this.Controlador.Buscador.Filtros.Valores.Tag = this.Controlador.Buscador.Filtros.Tags.findIndex( x => x.Id == 'preparando-retira-cliente' ); this.Controlador.Buscador.Buscar( 1 ); },
                Opciones: []
            };

            this.Valores.push( preparando );

          

            let finalizados = {
                Titulo: 'Finalizados',
                Valor: this.Estadistica.Datos.finalizados.total,
                Accion: () => { this.Controlador.Buscador.Filtros.Valores.Tag = this.Controlador.Buscador.Filtros.Tags.findIndex( x => x.Id == 'finalizados' ); this.Controlador.Buscador.Buscar(1); },
            };
            this.Valores.push( finalizados );

            this.Cargando = false;
        }


    }
